export const MENU = 'menu';

export const MENU_ACTIONS_NAME = {
  getMenu: `${MENU}/getMenu`,
};

export const MENU_MUTATIONS_NAME = {
  setMenu: `${MENU}/setMenu`,
};

export const MENU_GETTERS_NAME = {
  getMenu: `${MENU}/getMenu`,
};
